// import React, { userState } from 'react'
import './Navbar.css'
import './HeroSection.jsx'
import './UXcasestudies.jsx'
import {Link} from "react-router-dom";
import LogoImg from '../images/sathya-logo.png'


function Navbar() {
  return (
    <>  <></>
    
    <div>
      <header>

        <Link to = "/">
          <h1 className ='MyLogo'>
              <img className='MyLogoImg' src={LogoImg}  alt="" /> 
          </h1>
        </Link> 


        <nav>

         <Link to = "/casestudies">
          <p className="MyBtn1" href=""> <span id="crcl"> </span> UX Case studies</p> 
        </Link>

        <Link to ="/design">
          <p className="MyBtn2"><span id="crcl"> </span> Design</p>
        </Link>

        {/* <Link to="/devprojects">
          <p className="MyBtn2"><span id="crcl"> </span> &lt;Dev Projects&gt;</p>
        </Link> */}


        <Link to="/about">
          <p className="MyBtn3"><span id="crcl"> </span>  About</p>
        </Link>

        {/* <Link to = "/sayhello"> 
          <p className="MyBtn4"><span id="crcl"> </span>  Say Hello</p>
        </Link> */}

        </nav>

      </header>

    </div>
    </>
  )
}

export default Navbar